import { AxiosError } from 'axios';
import { translate, translationKeys } from 'logic/translations/translations.service';

export const getAxiosErrorMessage = (error: AxiosError | undefined) =>
  error?.response?.data.message || error?.message || translate(translationKeys.errors.unknownError);
